(function () {
  'use strict';

  var CART_URL = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

  function bindButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('.predictive-search__add-to-cart[data-variant-id]');

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.dataset.atcBound === '1') continue;
      btn.dataset.atcBound = '1';
      btn.addEventListener('click', onClick, true);
    }
  }

  function onClick(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    var btn = e.currentTarget;
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    var original = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch(CART_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Add to cart failed');
          });
        }
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Added';
        btn.classList.add('added');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('added');
          btn.disabled = false;
        }, 1500);
      })
      .catch(function (err) {
        console.warn('[predictive-search-atc]', err);
        btn.textContent = 'Error';
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      });
  }

  function observePredictiveSearch() {
    var ps = document.querySelector('predictive-search');
    if (!ps || !('MutationObserver' in window)) return;

    var observer = new MutationObserver(function () {
      bindButtons(ps);
    });

    observer.observe(ps, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    bindButtons(document);
    observePredictiveSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    bindButtons(document);
  });
})();